import { render, staticRenderFns } from "./app-alerts.vue?vue&type=template&id=58eedf72"
import script from "./app-alerts.vue?vue&type=script&lang=js"
export * from "./app-alerts.vue?vue&type=script&lang=js"
import style0 from "./app-alerts.vue?vue&type=style&index=0&id=58eedf72&prod&module=true&lang=sass"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports